import type { CMVarAggregationType, ICMVarAggregationMapType, StateSnapshot } from '@iotv/iotv-v3-types'

export class CMVarAggregationMap {
  data: { [k: string]: CMVarAggregationObject } = {}

  constructor(currentMap?: ICMVarAggregationMapType) {
    if (currentMap) {
      Object.entries(currentMap.data).forEach(([k, v]) => [(this.data[k] = new CMVarAggregationObject(v))])
    }
  }

  update = (snapshot: StateSnapshot<any>) => {
    Object.entries(snapshot.state).forEach(([k, v]) => {
      if (typeof v === 'number') {
        if (!this.data[k]) {
          this.data[k] = new CMVarAggregationObject()
        }
        this.data[k].update(v, snapshot.timestamp)
      }
    })
  }
}

export class CMVarAggregationObject {
  firstTimestamp: number | undefined = undefined
  lastTimeStamp: number | undefined = undefined
  cn: number = 0
  mean: number = 0
  sqDiffFromMean: number = 0
  max?: number = undefined
  min?: number = undefined

  constructor(aggregation?: CMVarAggregationType) {
    if (aggregation) {
      this.firstTimestamp = aggregation.firstTimestamp
      this.lastTimeStamp = aggregation.lastTimeStamp
      this.cn = aggregation.cn
      this.mean = aggregation.mean
      this.sqDiffFromMean = aggregation.sqDiffFromMean
      this.max = aggregation.max
      this.min = aggregation.min
    }
  }

  update = (newValue: number, timestamp: number = Date.now()) => {
    this.cn++
    const delta = newValue - this.mean
    this.mean += delta / this.cn
    const delta2 = newValue - this.mean
    this.sqDiffFromMean += delta * delta2
    if (!this.firstTimestamp) this.firstTimestamp = timestamp
    this.lastTimeStamp = timestamp // ??? Should this not check for max or min?
    this.max = this.max ? Math.max(this.max, newValue) : newValue
    this.min = this.min ? Math.min(this.min, newValue) : newValue

    if (this.sqDiffFromMean > Number.MAX_SAFE_INTEGER) {
      this.sqDiffFromMean = Number.MAX_SAFE_INTEGER
    }
    if (this.sqDiffFromMean < Number.MIN_SAFE_INTEGER) {
      this.sqDiffFromMean = Number.MIN_SAFE_INTEGER
    }
    return this
  }

  get variancePop() {
    return this.cn > 1 ? this.sqDiffFromMean / this.cn : 0
  }

  get varianceSample() {
    return this.cn > 2 ? this.sqDiffFromMean / (this.cn - 1) : 0
  }

  get sdPop() {
    return Math.pow(this.variancePop, 0.5)
  }

  get sdSample() {
    return Math.pow(this.varianceSample, 0.5)
  }
}
